import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

type BrandIconProps = {
  size?: number;
  sx?: SxProps<Theme>;
  alt?: string;
};

const BrandIcon: React.FC<BrandIconProps> = ({ size = 24, sx, alt = "PocketBalance" }) => {
  return (
    <Box
      component="img"
      src="/favicon.svg"
      alt={alt}
      sx={{ width: size, height: size, display: "inline-block", ...sx }}
    />
  );
};

export default BrandIcon;


